import React from 'react';
import DatePicker from 'react-datepicker';
import DatePickerWrapper from './DatePickerWrapper';
import ComponentLink from './ComponentLink';
import Loader from 'react-loader';
import * as utils from '../util';

export default class CustomPeriodControl extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedHolidays: [],
            displaySelectedHolidays: this.props.holidays.substring(0,3),
            showTonarValidationAlert: false,
            showSpreadValidationAlert: false,
            showRateAlert:false
        }
        this.state.selectedHolidays.push(this.props.holidays.substring(0,3));
    }

    handleCheckbox = (e, s) => {
        const selectedHolidays = [...this.state.selectedHolidays];
        if (e.target.checked) {
            selectedHolidays.push(s)
        } else {
            if (selectedHolidays.length != 1) {
                const index = selectedHolidays.findIndex((ch) => ch === s);
                selectedHolidays.splice(index, 1);
            }
        }
        this.setState({ selectedHolidays, displaySelectedHolidays: selectedHolidays.join(',') }, () => {
            this.props.handleHolidaysChange(this.state.selectedHolidays);
        })
    }

    // thousand separator changes
    numberWithCommas = (x) => {
        if(x==='N/A')
            return x;
        else
            return ((parseFloat(x).toLocaleString('en',{minimumFractionDigits: 2, maximumFractionDigits: 2})!=='NaN'? parseFloat(x).toLocaleString('en',{minimumFractionDigits: 2, maximumFractionDigits: 2}) : ""))
    }
    // thousand separator changes

    lagOptions = this.props.lagOptions;
    getCusLagsBtns = () => {
        let btns = [];
        for (let i = 0; i < this.lagOptions.length; i++) {
            btns.push(
                <button onClick={() => { this.props.handleLagCusChange(this.lagOptions[i] + 'd') }} className="dropdown-item" type="button">{this.lagOptions[i] + 'd'} </button>
            );
        }
        return btns;
    }

    holidayCalendarsOptions = this.props.holidayCalendarsOptions;
    getCusHolidays = () => {
        let btns = [];
        let selected = '';

        if (this.state.selectedHolidays.length === 1) {
            selected = this.state.selectedHolidays[0];
        }
        this.holidayCalendarsOptions.forEach(item => {
            let calendarCode = item.substring(0,3);
            btns.push(
                <div style={{ paddingLeft: '5px' }}>
                    <input type="checkbox" id={item} defaultChecked={item === this.props.holidays} disabled={selected === calendarCode ? true : false} onChange={(e) => this.handleCheckbox(e, item.substring(0,3))} on />{} {item}
                </div>
            );
        })
        return btns;
    }

    roundOptions= this.props.roundOptions;
    getCusRoundBtns = () => {
        let btns = [];
        for (let i = 0; i < this.roundOptions.length; i++) {
            btns.push(
                <button onClick={() => { this.props.handleRoundCusChange(this.roundOptions[i]) }} className="dropdown-item" type="button">{this.roundOptions[i]} </button>
            );
        }
        return btns;
    }

    dayCountOptions = this.props.dayCountOptions;
    getDayCount = () => {
        let btns = [];
        this.dayCountOptions.forEach(item => {
            btns.push(
                <button onClick={() => { this.props.handleDayCountConventionChange(item) }} className="dropdown-item" type="button">{item} </button>
            );
        })
        return btns;
    }

    endDateAdjustmentOptions = this.props.endDateAdjustmentOptions;
    getEndDateAdjustment = () => {
        let btns = [];
        this.endDateAdjustmentOptions.forEach(item => {
            btns.push(
                <button onClick={() => { this.props.handleEndDateAdjustmentChange(item) }} className="dropdown-item" type="button">{item} </button>
            );
        })
        return btns;
    }

    roundingRuleOptions = this.props.roundingRuleOptions
    getRoundingRule = () => {
        let btns = [];
        this.roundingRuleOptions.forEach(item => {
            btns.push(
                <button onClick={() => { this.props.handleCouponRoundingRuleChange(item) }} className="dropdown-item" type="button">{item} </button>
            );
        })
        return btns;
    }

    resetTypeOptions = this.props.resetTypeOptions
    getResetType = () => {
        let btns = [];
        this.resetTypeOptions.forEach(item => {
            btns.push(
                <button onClick={() => { this.props.handleResetTypeChange(item) }} className="dropdown-item" type="button">{item} </button>
            );
        })
        return btns;
    }
    negativeInterestRateOptions = this.props.negativeInterestRateTypes
    getNegativeInterestRateOptions = () => {
        let btns = [];
        this.negativeInterestRateOptions.forEach(item => {
            btns.push(
                <button onClick={() => { this.props.handleNegativeInterestRateChange(item) }} className="dropdown-item" type="button">{item} </button>
            );
        })
        return btns;
    }

    validateTonarNotional = (event) =>{
        this.props.handleNotionalCusChange(event);
        const value = event.target.value;
        this.setState({showTonarValidationAlert: (value === '' || utils.ValidateInteger(value) ? false : true)});        
    }

    validateSpreadDecimalPlaces = (event) =>{
        this.props.handleSpreadCusChange(event);
        const value = event.target.value;
        this.setState({showSpreadValidationAlert: (value === '' || utils.validateNumberWithDecimalPlaces(value,utils.spreadDecimalPlaces) ? false : true)});        
    }



    render() {
        var startDateCustom = this.props.startDateCustom ? this.props.startDateCustom : null;
        var endDateCustom = this.props.endDateCustom ? this.props.endDateCustom : null;
        var rate = this.props.outputValCustom ? this.props.outputValCustom.rate : null;
        var paymentCustom = this.props.outputValCustom ? this.props.outputValCustom.payment : null;
        var all_in_rate = this.props.outputValCustom ? this.props.outputValCustom.all_in_rate : null;
        var instrumentType = this.props.instrumentType ? this.props.instrumentType : null;
        const maxDate = new Date();
        const url = utils.createCustomFilterUrl(instrumentType, this.props.startDateCustom, this.props.endDateCustom,
            this.props.roundCus, this.props.lagCus, this.props.notionalCustom, this.props.spreadCustom, this.props.dayCount, this.props.endDateAdjustment, this.props.roundingRule, this.state.selectedHolidays, this.props.resetType, this.props.defaultEndDateAdjustment, this.props.defaultDayCount, this.props.defaultRoundingRule, this.props.defaultResetType, this.props.negativeInterestType, this.props.floorLvl);
        const isStartEff = this.props.outputValCustom ? utils.compareDate(this.props.startDateCustom, this.props.outputValCustom.effective_start_date) : true
        const isEndCustom = this.props.outputValCustom ? utils.compareDate(this.props.endDateCustom, this.props.outputValCustom.effective_end_date) : true
        const show_div = this.props.showAdvanceOptions ? "displayBlock" : "displayNone";
        const displaySelectedHolidays = this.state.displaySelectedHolidays
        return (
            <div>
                <div key={'custom_filter'} className="row small">
                    <div className='custom-lg-size col-lg-12 col-md-12 col-sm-12'>
                        <div className="custom-lg-dates-size col-lg-2 col-md-3 col-sm-6 col-xs-6 comboComp textMinWid mb-1">
                            <label className="alignComboR">Start </label>
                            <DatePicker
                                id="datepicker"
                                className='datepicker_cus'
                                selected={startDateCustom}
                                dateFormat="dd/MM/yyyy"
                                onChange={this.props.handleStartDateCusChange}
                                showYearDropdown
                                scrollableYearDropdown
                                maxDate={maxDate}
                                yearDropdownItemNumber={15}
                                customInput={<DatePickerWrapper />}
                            />
                            {!isStartEff && !this.props.loadingSecondGrid ? <span title={'Effective :' + this.props.outputValCustom.effective_start_date}><sup className="redText">1</sup></span> : null}
                        </div>
                        <div className="custom-lg-dates-size col-lg-2 col-md-3 col-sm-6 col-xs-6 comboComp textMinWid mb-1">
                            <label className="alignComboR">End </label>
                            <DatePicker
                                id="datepicker"
                                className='datepicker_cus'
                                selected={endDateCustom}
                                dateFormat="dd/MM/yyyy"
                                maxDate={this.props.maxDate15}
                                onChange={this.props.handleEndDateCusChange}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={15}
                                customInput={<DatePickerWrapper />}
                            />
                            {!isEndCustom && !this.props.loadingSecondGrid ? <span title={'Effective :' + this.props.outputValCustom.effective_end_date} ><sup className="redText">1</sup></span> : null}
                        </div>
                        <div className="custom-lg-size col-lg-1 col-md-2 col-sm-6 col-xs-6 comboComp mb-1">
                            <label className="alignComboR" title="Lag in business days">Lag</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Lag in business days">
                                    {this.props.lagCus}
                                </button>
                                <div className="dropdown-menu col-md-3" aria-labelledby="dropdownMenu2">
                                    {
                                        this.getCusLagsBtns()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="custom-lg-spread-size col-lg-1 col-md-3 col-sm-6 col-xs-6 comboComp mb-1">
                            <label className="alignComboR" title="Additional spread (aka margin) to apply to rate to obtain all-in rate for payment calculation." >Spread (%) </label>
                            <input className="col-md-8 col-sm-7 col-xs-7  text-box-option-spread " placeholder="0.0" value={this.props.spreadCustom} onKeyDown={this.props.keyPressCoupon} type='text' onBlur={this.props.calcCoupon} onChange={this.validateSpreadDecimalPlaces}></input>
                            <div className={"col-sm-12 validationBox validationAlign validation " + (this.state.showSpreadValidationAlert ? " show" : " hide")}>
                                    Spread can be a positive number with up to 6 decimal places.
                            </div> 
                        </div>
                        <div className="custom-lg-size col-lg-2 col-md-3 col-sm-6 col-xs-6 comboComp mb-1">
                            <label className="alignComboR" title="Rate: all-in-rate including annualised compounded rate for period + manually set Spread (%)">Rate:</label>
                            {this.props.loadingSecondGrid ? <Loader className="loader" color='#6f2c91' scale='0.48' loaded={false} /> :
                                this.props.isGridTwoError || paymentCustom === null ? <div className='content'>{Error}</div> : <ComponentLink value={all_in_rate} url={url} pad={this.props.roundCus} className="alignComboR" apiResponse={JSON.stringify(this.props.outputValCustom) } isLinkRequired="false" />}
                            <div className={"col-sm-12 validationBoxSecond validationAlign validation " + (this.props.outputValCustom.isFloored ? " show" : " hide")}>
                                Rate is subject to Floor Level.
                            </div>
                        </div>
                        {this.props.instrumentType=='TONAR'?
                            <div className="custom-lg-notional-size col-lg-2 col-md-4 col-sm-6 col-xs-6 comboComp mb-1">
                                <label className="alignComboR" title="Base notional to apply rate and spread to when calculating payment." >Notional ({this.props.currency}) </label>
                                <input className=" col-md-8 col-sm-7 col-xs-7  text-box-option" placeholder="0" value={this.props.notionalCustom} onKeyDown={this.props.keyPressCoupon} type='text' onBlur={this.props.calcCoupon} onChange={this.validateTonarNotional}></input>
                                <div className={"col-sm-12 validationBoxThird validationAlign validation " + (this.state.showTonarValidationAlert ? " show" : " hide")}>
                                    Notional(¥), can only be positive integer value.
                                </div>
                            </div>
                            :
                            <div className="custom-lg-notional-size col-lg-2 col-md-4 col-sm-6 col-xs-6 comboComp mb-1">
                                <label className="alignComboR" title="Base notional to apply rate and spread to when calculating payment." >Notional ({this.props.currency}) </label>
                                <input className=" col-md-8 col-sm-7 col-xs-7  text-box-option" placeholder="0.00" value={this.props.notionalCustom} onKeyDown={this.props.keyPressCoupon} type='text' onBlur={this.props.calcCoupon} onChange={this.props.handleNotionalCusChange}></input>
                            </div>
                        }
                        <div className="custom-lg-size col-lg-2 col-md-3 col-sm-6 col-xs-6 comboComp mb-1">
                            <label className="alignComboR">Payment :</label>
                            {/* // thousand separator changes */}
                            {this.props.loadingSecondGrid ? <Loader className="loader" color='#6f2c91' scale='0.48' loaded={false} /> :
                                this.props.isGridTwoError || paymentCustom === null ? <div className='content'>{Error}</div> : <ComponentLink value={this.numberWithCommas(paymentCustom)} url={url} pad={this.props.roundCus} className="marginTop" apiResponse={JSON.stringify(this.props.outputValCustom)} />}
                            {/* // thousand separator changes */}
                        </div>
                        <br/><br/><br/>
                    </div>                   
                </div>

                <div className='row small'>
                    <div className='col-md-12 col-sm-12'>
                        <div className="col-md-1 col-sm-6 col-xs-12 comboComp mb-1">
                            <button className="option-title button-down" type="button" onClick={this.props.showOptions}>Advanced Options<i className={this.props.showAdvanceOptions ? "single-down-arrow single-up-arrow" : "single-down-arrow"} /> </button>
                        </div>
                    </div>
                </div>
                
                <div className={"row small " + show_div}>
                    <div className='col-md-12 col-sm-12'>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR" title="Holiday calendar(s) to consider when applying modified following rules for End Date.">Payment Holidays</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle btn-ellipsis" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
                                    {displaySelectedHolidays}
                                </button>
                                <div style = {{minWidth:'160px'}} className="dropdown-menu col-md-3" aria-labelledby="dropdownMenu2">
                                    {
                                        this.getCusHolidays()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR">Rounding (dps)</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {this.props.roundCus}
                                </button>
                                <div className="dropdown-menu col-md-3" aria-labelledby="dropdownMenu2">
                                    {
                                        this.getCusRoundBtns()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR" title="Number of days to use for the annualised accrual period.">Day Count Convention</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="dayCountDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {this.props.dayCount}
                                </button>
                                <div className="dropdown-menu col-md-3" aria-labelledby="dayCountDropdownMenu">
                                    {
                                        this.getDayCount()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR" title="ADJUSTED: apply Modified Following rule (or applicable day convention) where end date falls on a non-business day 
UNADJUSTED: provides support for rare occasion when maturity permitted on a non-business day, eg a Saturday; when UNADJUSTED do not apply Modified Following rule, and calculate just to specified end date for observation period
.">End Date Adjustment</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="endDateAdjustDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {this.props.endDateAdjustment}
                                </button>
                                <div className="dropdown-menu col-md-3" aria-labelledby="endDateAdjustDropdownMenu">
                                    {
                                        this.getEndDateAdjustment()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-5 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR" title="Standard rounding (to nearest decimal), round up or round down for payment amount.">Payment Rounding Rule</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="roudingDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    {this.props.roundingRule}
                                </button>
                                <div className="dropdown-menu col-md-3" aria-labelledby="roudingDropdownMenu">
                                    {
                                        this.getRoundingRule()
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 comboComp mb-1">
                            <label className="alignComboR" title="When reset_lag is specified, does the observation period for compound calculation also shift back by same lag (SHIFT-aka 'BACKWARD_SHIFT') or does it remain aligned to the interest period (LAG-aka 'RESET_DAYS_PRIOR').">Reset Type</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="resetTypeDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Day weighting convention">
                                    {this.props.resetType}
                                </button>
                                <div style = {{minWidth:'160px'}} className="dropdown-menu col-md-3" aria-labelledby="resetTypeDropdownMenu">
                                    {
                                        this.getResetType()
                                    }
                                </div>
                            </div>
                        </div>



                        {/* new row with 3 components for negative interest rates */}
                        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 comboComp mb-1">
                        <label className="alignComboR" title="">Negative Rate Handling</label>
                            <div className="dropdown">
                                <button className="btn btn-secondary dropdown-toggle" type="button" id="negativeRateDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Negative Rate Handling">
                                    {this.props.negativeInterestType}
                                </button>
                                <div style = {{minWidth:'160px'}} className="dropdown-menu col-md-3" aria-labelledby="negativeRateDropdownMenu">
                                    {
                                        this.getNegativeInterestRateOptions()
                                    }
                                </div>
                            </div>
                        </div>

                        {this.props.negativeInterestType != 'NoFloor' ?
                            <div className="col-lg-3 col-md-5 col-sm-6 col-xs-12 comboComp mb-1">
                                <label className="alignComboR">Floor Level (%) </label>
                                <input className="col-md-8 col-sm-7 col-xs-7  text-box-option-small"
                                    placeholder="0.0"
                                    value={this.props.floorLvl}
                                    onKeyDown={this.props.keyPressCoupon}
                                    type='text'
                                    onBlur={this.props.calcCoupon}
                                    onChange={this.props.handleFloorLvlChange}>
                                </input>
                            </div>
                            : null}








                    </div>
                </div>
            </div>
        );
    }
}  


// WEBPACK FOOTER //
// ./src/components/CustomPeriodControl.js